import axios from '../axios';

const fetchActiveChannels = async (botId: string) => {
  const { data } = await axios.get(`/telegram-channels/${botId}`);

  return data;
};

export default fetchActiveChannels;
